import React from "react"
import { useTranslation } from "react-i18next"
import { Card, Container } from "reactstrap"
import SAR_logo from "assets/images/login/sar-logo-2.svg"
import alyamama_logo from "assets/images/login/alyamama_logo.svg"
import { Link } from "react-router-dom"
import { ArrowLeft } from "lucide-react"

const TermsConditions = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Container>
        <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light p-4">
          <Card className="p-4 shadow-lg rounded-3">
            <div className="g_center mb-2">
              <Link to={"/login"}>
                <img src={SAR_logo} width={110} height={61} alt="" />
                <img src={alyamama_logo} width={110} height={61} />
              </Link>
            </div>
            <Link to={"/login"} className="text-decoration-underline fs-5">
              <ArrowLeft size={15} /> {t("Login")}
            </Link>
            <h2 className="text-center fw-bold mb-4 text-primary">
              {t("Terms and Conditions")}
            </h2>
            <div className="overflow-auto">
              <p>
                {t(
                  "Welcome to the Seasonal Jobs Program on Al Mashaaer Al Mugaddassah Metro Line for the Hajj season 1446 H. Please read the following terms and conditions carefully before proceeding."
                )}
              </p>
              <h3 className="fw-semibold mt-3">{t("1. Eligibility")}</h3>
              <p>
                -{" "}
                {t(
                  "Applicants must be legally eligible to work in the Hajj season."
                )}
              </p>
              <p>
                -{" "}
                {t(
                  "All employees must comply with local regulations and company policies."
                )}
              </p>
              <h3 className="fw-semibold mt-3">
                {t("2. Work Responsibilities")}
              </h3>
              <p>
                -{" "}
                {t(
                  "Employees are expected to adhere to assigned schedules and perform duties as instructed."
                )}
              </p>
              <p>
                -{" "}
                {t(
                  "Any violation of company policies may result in termination."
                )}
              </p>
              <h3 className="fw-semibold mt-3">{t("3. Code of Conduct")}</h3>
              <p>
                -{" "}
                {t(
                  "Respect towards pilgrims, colleagues, and management is required at all times."
                )}
              </p>
              <p>- {t("Any misconduct will lead to disciplinary action.")}</p>
              <h3 className="fw-semibold mt-3">
                {t("4. Compensation and Benefits")}
              </h3>
              <p>
                -{" "}
                {t(
                  "Employees will receive their wages as per the agreed contract."
                )}
              </p>
              <p>
                -{" "}
                {t(
                  "Additional benefits may be provided depending on the role."
                )}
              </p>
              <h3 className="fw-semibold mt-3">{t("5. Health and Safety")}</h3>
              <p>
                -{" "}
                {t(
                  "Employees must adhere to all safety guidelines while on duty."
                )}
              </p>
              <p>
                -{" "}
                {t(
                  "Immediate reporting of any health issues or injuries is mandatory."
                )}
              </p>
              <h3 className="fw-semibold mt-3">{t("6. Termination Policy")}</h3>
              <p>
                -{" "}
                {t(
                  "The company reserves the right to terminate employment for rule violations."
                )}
              </p>
              <p>
                -{" "}
                {t(
                  "Employees may also terminate their contract with prior notice."
                )}
              </p>
              <h2 className="text-center fw-bold mb-4 text-primary">
                {t("Privacy Policy")}
              </h2>
              <p>
                {t(
                  'This privacy policy applies to the Yamama Crowd Management app (hereby referred to as "Application") for mobile devices that was created by Wulooj Information Technology (hereby referred to as "Service Provider") as a Free service. This service is intended for use "AS IS".'
                )}
              </p>

              <h4 className="fw-semibold mt-3">
                {t("Information Collection and Use")}
              </h4>
              <p>
                {t(
                  "The Application collects information when you download and use it. This information may include information such as"
                )}
              </p>
              <ul>
                <li>
                  {t(
                    "Your device's Internet Protocol address (e.g. IP address)"
                  )}
                </li>
                <li>
                  {t(
                    "The pages of the Application that you visit, the time and date of your visit, the time spent on those pages"
                  )}
                </li>
                <li>{t("The time spent on the Application")}</li>
                <li>
                  {t("The operating system you use on your mobile device")}
                </li>
              </ul>
              <p>
                {t(
                  "The Application does not gather precise information about the location of your mobile device."
                )}
              </p>
              <br />
              <p>
                {t(
                  "The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions."
                )}
              </p>
              <p>
                {t(
                  "For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, including but not limited to wulooj@gmail.com. The information that the Service Provider request will be retained by them and used as described in this privacy policy."
                )}
              </p>

              <h4 className="fw-semibold mt-3">{t("Third Party Access")}</h4>
              <p>
                {t(
                  "Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement."
                )}
              </p>
              <br />
              <p>
                {t(
                  "Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:"
                )}
              </p>
              <br />
              <ul>
                <li>
                  <a
                    href="https://www.google.com/policies/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Google Play Services")}
                  </a>
                </li>
                <li>
                  <a
                    href="https://firebase.google.com/support/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Google Analytics for Firebase")}
                  </a>
                </li>
              </ul>
              <p>
                {t(
                  "The Service Provider may disclose User Provided and Automatically Collected Information:"
                )}
              </p>
              <ul>
                <li>
                  {t(
                    "as required by law, such as to comply with a subpoena, or similar legal process;"
                  )}
                </li>
                <li>
                  {t(
                    "when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;"
                  )}
                </li>
                <li>
                  {t(
                    "with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement."
                  )}
                </li>
              </ul>

              <h4 className="fw-semibold mt-3">{t("Opt-Out Rights")}</h4>
              <p>
                {t(
                  "You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network."
                )}
              </p>

              <h4 className="fw-semibold mt-3">{t("Data Retention Policy")}</h4>
              <p>
                {t(
                  "The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at wulooj@gmail.com and they will respond in a reasonable time."
                )}
              </p>

              <h4 className="fw-semibold mt-3">{t("Children")}</h4>
              <p>
                {t(
                  "The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13."
                )}
              </p>
              <br />
              <p>
                {t(
                  "The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (wulooj@gmail.com) so that they will be able to take the necessary actions."
                )}
              </p>

              <h4 className="fw-semibold mt-3">{t("Security")}</h4>
              <p>
                {t(
                  "The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains."
                )}
              </p>

              <h4 className="fw-semibold mt-3">{t("Changes")}</h4>
              <p>
                {t(
                  "This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes."
                )}
              </p>
              <br />
              <p>{t("This privacy policy is effective as of 2025-05-06")}</p>

              <h4 className="fw-semibold mt-3">{t("Your Consent")}</h4>
              <p>
                {t(
                  "By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us."
                )}
              </p>

              <h4 className="fw-semibold mt-3">{t("Contact Us")}</h4>
              <p>
                {t(
                  "If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at wulooj@gmail.com."
                )}
              </p>
            </div>
          </Card>
        </div>
      </Container>
    </div>
  )
}

export default TermsConditions
